
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talcum.claims/privacy-policy",
      function () {
        return require("private-next-pages/talcum.claims/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talcum.claims/privacy-policy"])
      });
    }
  